<template>
  <div class="mt-n5" v-if="loading">
    <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/lg-bx.svg" class="d-none d-lg-block w-100" alt="">
    <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/tab-bx.svg" class="d-none d-md-block d-lg-none w-100" alt="">
    <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/mob-bx.svg" class="d-block d-md-none d-lg-none w-100" alt="">
  </div>
<div v-if="!loading && brandData && settingsPerm">
  <div v-if="brandData" class='brands-header-wrapper'>
    <brandHeader v-bind:settingsPerm="settingsPerm" v-bind:brandInputData="brandData"></brandHeader>
  </div>
  <div class='d-flex flex-wrap p-0'>
    <div class="col-12 col-lg-9 p-0" v-if="brandData && settingsPerm">
      <!-- left side features wrapper  -->
      <brandRelatedFeatures
        v-bind:widgetMainOne="widgetMainOne ? widgetMainOne : undefined"
        v-bind:widgetMainTwo="widgetMainTwo ? widgetMainTwo : undefined"
        v-bind:rightSideWidgetTop="rightSideWidgetTop ? rightSideWidgetTop : undefined"
        v-bind:rightSideWidgetBottom="rightSideWidgetBottom ? rightSideWidgetBottom : undefined"
        v-bind:settingsPerm="settingsPerm ? settingsPerm : undefined"
        v-bind:brandInputData="brandData"
      >
      </brandRelatedFeatures>

      <div v-if="brandData && brandData.brandComplex && brandData.brandComplex.BrandComplex 
      && brandData.brandComplex.BrandComplex.categoryIds && brandData.brandComplex.BrandComplex.categoryIds.length">
        <div v-for="(aCategoryId, index) in brandData.brandComplex.BrandComplex.categoryIds.slice(0,4)" :key="index" class="my-5">
          <categoryFeature 
          v-bind:aCategoryId="aCategoryId" 
          v-bind:brandData="brandData.brandComplex.BrandComplex"
          v-bind:categories="brandData.brandComplex.BrandComplex.categories"
          v-bind:settingsPerm="settingsPerm ? settingsPerm : undefined"
          ></categoryFeature>
        </div>
      </div>
    </div>
     <!-- rightSIde widgets wrapper  -->
    <div class='d-none d-lg-block col-3 pr-0'>
      <div class="pl-3 right-side-wrapper-sticky">
        <div class="top-widget-zindex" v-if="rightSideWidgetTop">
          <span v-html="rightSideWidgetTop"></span>
        </div>
        <div class="mt-3 bottom-widget-zindex" v-if="rightSideWidgetBottom">
          <span v-html="rightSideWidgetBottom"></span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import brandHeader from './BrandHeader.vue';
import brandRelatedFeatures from './brandRelatedFeatures.vue';
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import categoryFeature from './CategoryFeature.vue';

export default {
  name: "brandMain",

  created() {
    if (this.settingsPerm && this.settingsPerm.brandsWidgetsData) {
      this.filterOutWidgetsFromWPData();
    }
    if (this.settingsPerm && this.settingsPerm.brandSlug) {
      this.loading = true;
      this.getBrandsData();
    } else {
      this.loading = false;
    }
  },

  components: {
    brandHeader,
    brandRelatedFeatures,
    categoryFeature,
  },

  data() {
    return {
      widgetMainOne: false,
      widgetMainTwo: false,
      rightSideWidgetTop: false,
      rightSideWidgetBottom: false,
      brandSlug: false,
      brandData: null,
      loading: true,
    };
  },

   props: { 
    settingsPerm: Object,
  },

  methods: {
    filterOutWidgetsFromWPData() {
      if (this.settingsPerm.brandsWidgetsData) {
        let brandSpecificWidgets = this.settingsPerm.brandsWidgetsData.brand_slug_based_widget? this.settingsPerm.brandsWidgetsData.brand_slug_based_widget : {};
        let gloabWidgets = this.settingsPerm.brandsWidgetsData;
        this.widgetMainOne = brandSpecificWidgets.main_widget_inside_content_one? brandSpecificWidgets.main_widget_inside_content_one : gloabWidgets.mainGlobalFirst;
        this.widgetMainTwo = brandSpecificWidgets.main_widget_inside_content_second? brandSpecificWidgets.main_widget_inside_content_second : gloabWidgets.mainGlobalSecond;
        this.rightSideWidgetTop = brandSpecificWidgets.brand_right_side_first_sidebar? brandSpecificWidgets.brand_right_side_first_sidebar : gloabWidgets.rightSideGlobalFirst;
        this.rightSideWidgetBottom = brandSpecificWidgets.brand_right_side_second_sidebar? brandSpecificWidgets.brand_right_side_second_sidebar : gloabWidgets.rightSideGlobalSecond;
      }
    },

    getBrandsData(){
      let concordData;
      let brandSlug = this.settingsPerm.brandSlug;
      concordData = queryAndMutaionService.getBrandData(brandSlug);
      if (concordData && concordData.result) {
        this.brandData = concordData.result;
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 992px) {
    .right-side-wrapper-sticky {
        position: sticky;
        top: 75px;
    }

    .bottom-widget-zindex{
        position: sticky;
        top: 150px;
        z-index: 50;
    }

    .top-widget-zindex{
        z-index: 100;
    }
}
</style>